import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const Drawer = ({ isOpen, setIsOpen, children }) => {
    return (
        <div className={`fixed inset-0 z-50 ${isOpen ? 'block' : 'hidden'}`}>
            {/* Backdrop */}
            <div 
                className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                onClick={() => setIsOpen(false)}
            />

            {/* Drawer Panel */}
            <div className="fixed inset-y-0 right-0 w-full max-w-md transform transition-transform duration-300 ease-in-out">
                <div className="relative flex h-full flex-col overflow-y-auto bg-white shadow-xl">
                    {/* Header */}
                    <div className="flex items-center justify-between px-4 py-6">
                        <h2 className="text-lg font-medium text-gray-900">Menu</h2>
                        <button
                            type="button"
                            className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                            onClick={() => setIsOpen(false)}
                        >
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>

                    {/* Content */}
                    <div className="relative flex-1 px-4 py-6">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Drawer; 